import { createBrowserRouter, redirect } from 'react-router-dom'

import Layout from '~/components/layouts'
import { TOKEN_KEY } from '~/constants/storage'
import Page404 from '~/pages/404'
import AgentList from '~/pages/agent-list'
import AttendanceReviewPage from '~/pages/attendance-review'
import CardList from '~/pages/card-list'
import Login from '~/pages/login'
import OrderList from '~/pages/order-list'
import Overview from '~/pages/overview'
import PackageList from '~/pages/package-list'
import Password from '~/pages/password'
import StudentList from '~/pages/student-list'
import TeacherList from '~/pages/teacher-list'
import TeacherReview from '~/pages/teacher-review'
import TextbookCategoryList from '~/pages/textbook-category-list'
import TextbookList from '~/pages/textbook-list'
import LessonsPage from '~/pages/lessons'
import ClassRecordStatisticsDetails from '~/pages/class-record-statistics-details'
import SalaryPayoutPage from '~/pages/salary-payout'
import TeacherContractPage from '~/pages/teacher-contract'
import TeacherPerformancePage from '~/pages/teacher-performance'
import { isAdmin } from '~/utils/auth'

function isLogin() {
  const token = localStorage.getItem(TOKEN_KEY)
  if (token) {
    return true
  } else {
    return false
  }
}
export default createBrowserRouter([
  {
    path: '/',
    loader: () => {
      if (isLogin()) {
        return redirect('/home/overview')
      } else {
        return redirect('/login')
      }
    },
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/home',
    element: <Layout />,
    loader: () => {
      if (isLogin()) {
        return true
      } else {
        return redirect('/login')
      }
    },
    children: [
      { path: 'teacher-performance', loader: () => isAdmin() ? true : redirect('/404'), element: <TeacherPerformancePage /> },
      {
        path: 'overview',
        element: <Overview />,
      },
      {
        path: 'teacher-list',
        element: <TeacherList />,
      },
      {
        path: 'teacher-schedule-list',
        loader: () => redirect('/home/upcoming-appointments?view=availability'),
      },
      {
        path: 'teacher-review',
        element: <TeacherReview />,
      },
      {
        path: 'class-record-statistics',
        loader: () => redirect('/home/course-records?view=teachers'),
      },
      {
        path: 'salary-payout',
        element: <SalaryPayoutPage />,
      },
      {
        path: 'teacher-contracts',
        loader: () => isAdmin() ? true : redirect('/404'),
        element: <TeacherContractPage />,
      },
      {
        path: 'class-record-statistics/details',
        loader: () => isAdmin() ? true : redirect('/404'),
        element: <ClassRecordStatisticsDetails />,
      },
      {
        path: 'student-list',
        element: <StudentList />,
      },
      {
        path: 'textbook-list',
        element: <TextbookList />,
      },
      {
        path: 'textbook-category-list',
        element: <TextbookCategoryList />,
      },
      {
        path: 'package-list',
        element: <PackageList />,
      },
      {
        path: 'appointment-list',
        loader: () => redirect('/home/upcoming-appointments'),
      },
      {
        path: 'course-records',
        loader: () => isAdmin() ? true : redirect('/404'),
        element: <LessonsPage key="past" scope="PAST" />,
      },
      {
        path: 'upcoming-appointments',
        loader: () => isAdmin() ? true : redirect('/404'),
        element: <LessonsPage key="future" scope="FUTURE" />,
      },
      {
        path: 'attendance-review',
        loader: () => isAdmin() ? true : redirect('/404'),
        element: <AttendanceReviewPage />,
      },
      {
        path: 'card-list',
        element: <CardList />,
      },
      {
        path: 'order-list',
        element: <OrderList />,
      },
      {
        path: 'agent-list',
        element: <AgentList />,
      },
      {
        path: 'class-record-list',
        loader: () => redirect('/home/course-records'),
      },
      {
        path: 'password',
        element: <Password />,
      },
    ],
  },
  {
    path: '*',
    element: <Page404 />,
  },
])
